import React, { ReactNode } from 'react';
import Text from '../Text/Text';
import Wrapper from '../Wrapper';
import './HorizontalCard.less';
import { TextColorTypes } from '../../types';

type textSizeType = 1 | 2 | 3 | 4;

type positionYType = 'center';

export type HorizontalCardType = {
  title: string | ReactNode;
  titlefontWeight?: 'bold' | 'semiBold';
  active?: boolean;
  hover?: boolean;
  background?:
    | 'strong'
    | 'soft'
    | 'primary'
    | 'indicator'
    | 'active'
    | 'white'
    | 'gray-indicator'
    | 'soft-white'
    | 'primary-light';
  titleColor?: TextColorTypes;
  descriptionColor?: TextColorTypes;
  titleSize?: textSizeType;
  descriptionSize?: textSizeType;
  iconPositionY?: positionYType;
  actionsPositionY?: positionYType;
  description?: string | ReactNode;
  extraContent?: ReactNode;
  icon?: ReactNode;
  disabled?: boolean;
  onItemClick?: React.MouseEventHandler<HTMLDivElement>;
  actions?: {
    icon: ReactNode;
    onClick: React.MouseEventHandler<HTMLDivElement>;
  }[];
  padding?: 'xs' | 'sm' | 'md';
  borderRadius?: 'sm' | 'md' | 'lg' | 'xl';
  prefix?: React.ReactNode;
};
const HorizontalCard: React.FC<HorizontalCardType> = ({
  title,
  titlefontWeight,
  description,
  extraContent,
  icon,
  actions = [],
  onItemClick,
  active,
  background,
  titleColor,
  descriptionColor,
  titleSize = 2,
  descriptionSize = 3,
  iconPositionY,
  actionsPositionY,
  padding = 'md',
  disabled = false,
  hover = false,
  borderRadius = 'lg',
  prefix,
}) => {
  const classNames: String[] = ['horizontal-card-container'];
  classNames.push(
    `horizontal-card-container-border-${borderRadius}`,
    `horizontal-card-container-padding-${padding}`,
  );
  if (active) {
    classNames.push('horizontal-card-container-active');
  }
  if (background) {
    classNames.push(`horizontal-card-container-${background}`);
  }
  if (hover) {
    classNames.push(`horizontal-card-container-hover`);
  }
  if (disabled) {
    classNames.push(`horizontal-card-container-disabled`);
  }
  const titlefontWeightProps: any = {};
  if (titlefontWeight === 'bold') {
    titlefontWeightProps.bold = true;
  }
  if (titlefontWeight === 'semiBold') {
    titlefontWeightProps.semiBold = true;
  }
  return (
    <div className={classNames.join(' ')} onClick={onItemClick}>
      {prefix}
      <Wrapper display="flex" justifyContent="space-between">
        <Wrapper display="flex" alignItems={iconPositionY}>
          {icon && (
            <Wrapper display="flex" pr={1}>
              {icon}
            </Wrapper>
          )}
          <Wrapper>
            {typeof title !== 'string' ? (
              title
            ) : (
              <Text
                semiBold
                level={titleSize}
                rows={1}
                {...titlefontWeightProps}
                textColor={titleColor}
                title={String(title)}
              >
                {title}
              </Text>
            )}
            {description && (
              <Text
                textColor={descriptionColor}
                level={descriptionSize}
                rows={1}
                title={String(description)}
              >
                {description}
              </Text>
            )}
          </Wrapper>
        </Wrapper>
        {!!actions.length && (
          <Wrapper display="flex" alignItems={actionsPositionY}>
            <div className="actions-wrapper">
              {actions.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={'action-wrapper'}
                    onClick={item.onClick}
                  >
                    {item.icon}
                  </div>
                );
              })}
            </div>
          </Wrapper>
        )}
      </Wrapper>
      {!!extraContent && <Wrapper>{extraContent}</Wrapper>}
    </div>
  );
};

export default HorizontalCard;
